// const apiBaseUrls = "http://192.168.1.19:5000/";
// export const imageBaseUrls = "http://192.168.1.19:5000/assets/";
// const mainUrl = "";

// const apiBaseUrls = "http://191.101.80.117:5000/";


const apiBaseUrls = `${process.env.REACT_APP_API_URL}/`;
// const apiBaseUrls = "https://chriskelly.xyz/backend/";
// const apiBaseUrls = "http://localhost:5000/";

// export const imageBaseUrls = `${apiBaseUrls}assets/`;

// Uploads have lived on S3/CloudFront since the media migration; the API server's /assets
// folder no longer exists. Pointing at it is why every image in this panel rendered broken --
// the files were never lost, the panel was just asking a dead path for them.
const cdnBase = (process.env.REACT_APP_CDN_URL || "https://d3ste2v8jw54du.cloudfront.net").replace(/\/$/, "");

export const imageBaseUrls = (url) => {
    // Empty must stay empty. Returning a base path made "no image" look like a broken image,
    // because every `value ? url : placeholder` check saw a truthy string.
    if (!url) return "";

    if (url.startsWith("https://") || url.startsWith("http://") || url.includes("cloudinary")) {
        return url;
    }

    // Filenames come back with spaces and parentheses in them, so encode each segment.
    const clean = url.replace(/^\/+/, "");
    return `${cdnBase}/${clean.split("/").map(encodeURIComponent).join("/")}`;
};

/**
 * The filename of a freshly uploaded file.
 *
 * The upload endpoint returns `data.file.filename`. Every caller in this app was reading
 * `data.file.filename`, which the endpoint stopped returning when uploads moved to S3 -- so the
 * file uploaded fine and then an empty string was saved over the top of it. Reading both keeps
 * it working whichever field an endpoint returns.
 */
export const uploadedFilename = (res) =>
    res?.data?.file?.filename || res?.data?.file?.filename || "";


// One-time pass for "Login as". Replaces putting base64 of the user id
// straight in the URL, which anyone could forge.
/*
  "Login as <customer>" was answering 404 every time it was pressed.

  The auth routes are mounted at /api/auth (server.js), but this URL was built
  without the api segment, so the button POSTed to
  https://api.listit.ie/auth/impersonation-ticket - a path that does not exist.
  Every other constant in this file already carries api/ or admin/; this was
  the only one that didn't.

  Found in the access log: OPTIONS 204 then POST 404, on every attempt, going
  back as far as the log goes. Client reported it 11/10 as "I'm trying to make
  an adjustment" on a customer's advert.
*/
export const impersonationTicketUrl = `${apiBaseUrls}api/auth/impersonation-ticket`;

export const webSiteUrl = `${process.env.REACT_APP_WEBSITE_URL}/`;
export const dealerUrl = `${process.env.REACT_APP_DEALER_URL}/`;
// "Login as" a dealer must land on the portal THIS server builds (12/10).
// dealer.listit.ie still resolves to an old CloudFront copy (1 May build) in an
// AWS account we cannot reach; that copy cannot read Super Admin's one-time
// pass, so the button failed there. Point back at dealerUrl once the
// dealer.listit.ie DNS record is moved to this server.
export const dealerLoginAsUrl = "https://dealer2.listit.ie/";

// const apiBaseUrls = "http://localhost:5000/";
// export const imageBaseUrls = "http://localhost:5000/assets/";


export const ApiURLs = {
    login: `${apiBaseUrls}admin/auth/login`,
    CHANGE_PASSWORD: `${apiBaseUrls}admin/auth/change-password`,
    RESET_NEW_PASSWORD: `${apiBaseUrls}admin/auth/reset-new-password`,
    EDIT_PROFILE: `${apiBaseUrls}admin/auth/edit-profile`,
    UPLOAD_IMAGE_OLD: `${apiBaseUrls}api/upload-image`,
    UPLOAD_IMAGE: `${apiBaseUrls}api/upload-image-cloudinary`,

    UPLOAD_CHUNK: `${apiBaseUrls}api/upload-chunk`,
    MERGE_CHUNK: `${apiBaseUrls}api/merge-chunk`,

    FORGOT_PASSWORD: `${apiBaseUrls}admin/auth/forgot-password`,
    GET_USERS: `${apiBaseUrls}admin/user`,
    GET_DEALERS: `${apiBaseUrls}admin/dealers`,
    // What dealer info is collected vs still outstanding, and the manual sign-off on it.
    DEALER_DATA_SUMMARY: `${apiBaseUrls}admin/dealer-data-summary`,
    // Manufacturers offered when tagging a main (franchise) dealer. Derived from
    // live stock, so the list stays current without anyone maintaining it.
    DEALER_MAKES: `${apiBaseUrls}admin/dealer-makes`,
    DEALER_VERIFY: `${apiBaseUrls}admin/dealer`, // + /:id/verify
    DEALER_GOOGLE_SUGGESTION: `${apiBaseUrls}admin/dealer`, // + /:id/google-suggestion
    GET_OPENING_HOURS: `${apiBaseUrls}admin/opening-hours`,
    DELETE_USER: `${apiBaseUrls}admin/user-delete`,
    // Removing a duplicate: what is attached to the account, who holds a given
    // account number, and the move-everything-across operation itself.
    ACCOUNT_FOOTPRINT: `${apiBaseUrls}admin/user`, // + /:id/footprint
    ACCOUNT_BY_NUMBER: `${apiBaseUrls}admin/account-number`, // + /:number
    ACCOUNT_MERGE: `${apiBaseUrls}admin/user`, // + /:id/merge
    USER_UPDATE: `${apiBaseUrls}admin/user-update`,
    EMAIL_UPDATE: `${apiBaseUrls}admin/updateEmail`,
    CATEGORIES: `${apiBaseUrls}admin/category`,
    KEYWORDS: `${apiBaseUrls}admin/keywords`,
    KEYWORDSBULK: `${apiBaseUrls}admin/keywords-bulk`,

    ATTRIBUTE: `${apiBaseUrls}admin/attribute`,
    REORDER_ATTRIBUTE: `${apiBaseUrls}admin/reorder-attribute`,

    PLAN: `${apiBaseUrls}admin/plan`,
    // What each tier costs in each category. The tiers themselves are PLAN.
    PLAN_PRICING: `${apiBaseUrls}admin/plan-pricing`,
    AD_FEATURES: `${apiBaseUrls}admin/ad-features`,
    AD_FEATURE_GROUP: `${apiBaseUrls}admin/ad-feature-group`,
    AD_FEATURE_OPTION: `${apiBaseUrls}admin/ad-feature-option`,
    TIER: `${apiBaseUrls}admin/tier`,

    BANK: `${apiBaseUrls}admin/bank`,
    SOLD_ADS: `${apiBaseUrls}admin/sold-ads`,

    // Billing: who is being billed for what. Read-only, admin token required.
    BILLING_SUMMARY: `${apiBaseUrls}admin/billing/summary`,
    BILLING_SUBSCRIPTIONS: `${apiBaseUrls}admin/billing/subscriptions`,
    BILLING_PAYMENTS: `${apiBaseUrls}admin/billing/payments`,

    // One dealer: invoices, paid and unpaid, and the account access switch.
    BILLING_DEALER: `${apiBaseUrls}admin/billing/dealer`,
    BILLING_INVOICES: `${apiBaseUrls}admin/billing/invoices`,
    BILLING_RUN_MONTHLY: `${apiBaseUrls}admin/billing/invoices/run-monthly`,
    BILLING_SETTINGS: `${apiBaseUrls}admin/billing/settings`,
    BILLING_TEMPLATES: `${apiBaseUrls}admin/billing/templates`,
    BILLING_NOTIFICATIONS: `${apiBaseUrls}admin/billing/notifications`,
    BILLING_RUN_CREDIT_CONTROL: `${apiBaseUrls}admin/billing/credit-control/run`,

    // Discount codes. These only ever existed on listit.im before today.
    PROMOS: `${apiBaseUrls}admin/promos`,
    REMOVED_EXPIRED_ADS: `${apiBaseUrls}admin/removed-expired-ads`,

    ADMIN: `${apiBaseUrls}admin/admin`,

    VEHICLES: `${apiBaseUrls}admin/vehicles`,
    SUSPISIOUS: `${apiBaseUrls}admin/suspicious-activity`,
    // Every message ever sent. Reads message_archive, the copy that has no
    // foreign key on it, so threads deleted from the site are still readable.
    // ?site=self|peer - the sibling site's database is reached over a shared
    // secret, because conversation numbers collide across the two.
    MESSAGE_ARCHIVE: `${apiBaseUrls}admin/message-archive`,
    FINANCE: `${apiBaseUrls}admin/finance`,

    CONTACTUS: `${apiBaseUrls}admin/contact-us`,
    VEHICLESBULK: `${apiBaseUrls}admin/vehicles-bulk`,
    SETTINGS: `${apiBaseUrls}admin/setting`,
    GDPR: `${apiBaseUrls}admin/gdpr`,
    DASHBOARD: `${apiBaseUrls}admin/dashboard`,
    DASHBOARD_DEALER: `${apiBaseUrls}admin/dashboard-dealer`,
    MARKETPLACE_PULSE: `${apiBaseUrls}admin/marketplace-pulse`,
    VIEWS_TREND: `${apiBaseUrls}admin/views-trend`,
    ADVERTISER_MAP: `${apiBaseUrls}admin/advertiser-map`,
    AUDIT_LOGS: `${apiBaseUrls}admin/audit-logs`,

    ABOUT: `${apiBaseUrls}admin/about`,
    MEMBERS: `${apiBaseUrls}admin/members`,
    FEATURES: `${apiBaseUrls}admin/features`,

    CARREVIEW: `${apiBaseUrls}admin/car-review`,
    CARREVIEWFEATURE: `${apiBaseUrls}admin/car-review-features`,

    ANALYSIS: `${apiBaseUrls}admin/analysis`,
    VEHICLE_MAKE: `${apiBaseUrls}admin/vehicles-make-model`,
    SYNC_VEHICLES_DATA: `${apiBaseUrls}admin/sync-vehicles-data`,
    VEHICLE_MAKE_BULK: `${apiBaseUrls}admin/vehicles-make-model-bulk`,
    BLOG: `${apiBaseUrls}admin/blog`,
    FAQS: `${apiBaseUrls}admin/faq`,
    ADREPORTS: `${apiBaseUrls}admin/ad-report`,
    ADS: `${apiBaseUrls}admin/ads`,
    DEALER_APPLICATIONS: `${apiBaseUrls}admin/dealer-applications`,


    // Dealerships under one dealer account: a group runs several franchises off a
    // few forecourts, and each one has its own address, Eircode and phone.
    // GET takes ?user_id=, PUT and DELETE take /:id on the end.
    DEALER_BRANCHES: `${apiBaseUrls}admin/dealer-branches`,
    // The county list, so a dealership is filed under the same county id the
    // search filter uses rather than whatever was typed.
    GET_LOCATIONS: `${apiBaseUrls}api/user/get-location`,

    CREATEDEALER: `${apiBaseUrls}admin/create-dealer`,
    UPDATEDEALER: `${apiBaseUrls}admin/update-dealer`,
    INTERNAL_NOTES: `${apiBaseUrls}admin/internal-notes`,
    VERIFY_VAT: `${apiBaseUrls}admin/verify-vat`,
    ADD_BUMP_SPOTLIGHT: `${apiBaseUrls}admin/add-bump-spotlight`,

    // ADD_CATEGORY:`${apiBaseUrls}admin/category`,
};